/**
 * API-Client für Feld-Rezepte (Vorlage je Channel×Texttyp, Spec 2026-07-24 §3).
 *
 * Ausgelagert aus `channel-content-bulk.ts` wegen des 200-Zeilen-Limits.
 */

import apiClient from '../api-client'
import type { BulkAttributeCode, ChannelFieldRecipe } from './channel-content-bulk-types'
import { buildQuery } from './channel-content-bulk'

const BASE = '/api/v1'

/** Feld-Rezepte des Workspace, optional auf channel_ids gefiltert (Spec 2026-07-24). */
export async function getFieldRecipes(
  channelIds?: string[],
): Promise<{ success: boolean; recipes: ChannelFieldRecipe[] }> {
  const qs = channelIds && channelIds.length ? buildQuery({ channel_ids: channelIds.join(',') }) : ''
  const res = await apiClient.get(`${BASE}/channel-content/field-recipes${qs}`)
  return res.data
}

/** Vorlage je (Channel, Texttyp) anlegen/aktualisieren. */
export async function upsertFieldRecipe(payload: {
  channel_id: string
  attribute_code: BulkAttributeCode
  template_id?: string | null
  google_search?: boolean
  settings?: Record<string, unknown>
}): Promise<{ success: boolean; recipe?: ChannelFieldRecipe; error?: string }> {
  const res = await apiClient.put(`${BASE}/channel-content/field-recipes`, payload)
  return res.data
}
